const FILTER_PATH_SEPARATOR = '/-/';

/**
 * Extracts the base path (before the /-/ separator) from a full URL path or asPath string.
 * Returns the full path when no filter separator is present.
 */
export const extractBasePath = (asPath: string): string => {
  const pathOnly = asPath.split('?')[0].split('#')[0];
  const separatorIndex = pathOnly.indexOf(FILTER_PATH_SEPARATOR);
  return separatorIndex === -1 ? pathOnly : pathOnly.slice(0, separatorIndex);
};

/**
 * Parses filter pairs from the /-/ segment of a URL path or asPath string.
 *
 * For example: /earrings/-/p/-10/c/blue/c/red?sort=price-desc
 * → { p: ['-10'], c: ['blue', 'red'] }
 *
 * Values are percent-decoded. Returns an empty object when no filter segment is present.
 */
export const parseFilterPath = (asPath: string): Record<string, string[]> => {
  const pathOnly = asPath.split('?')[0].split('#')[0];
  const separatorIndex = pathOnly.indexOf(FILTER_PATH_SEPARATOR);

  if (separatorIndex === -1) {
    return {};
  }

  const filterSegment = pathOnly.slice(separatorIndex + FILTER_PATH_SEPARATOR.length);

  if (!filterSegment) {
    return {};
  }

  const segments = filterSegment.split('/');
  const result: Record<string, string[]> = {};

  for (let i = 0; i + 1 < segments.length; i += 2) {
    const alias = segments[i];
    const rawValue = segments[i + 1];

    if (!alias || rawValue === undefined) {
      continue;
    }

    let value = rawValue;

    try {
      value = decodeURIComponent(rawValue);
    } catch {
      value = rawValue;
    }

    if (result[alias]) {
      result[alias].push(value);
    } else {
      result[alias] = [value];
    }
  }

  return result;
};
